var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};



//////////////////
// WEBPACK FOOTER
// D:/Projects/angular/ecell-hcst/~/core-js/modules/_shared-key.js
// module id = ../../../../core-js/modules/_shared-key.js
// module chunks = 0